import React, { useState, useEffect } from 'react';
import { FaBuilding } from 'react-icons/fa';
import VisaoGeral from './tabs/VisaoGeral';
import Relacionamento from './tabs/Relacionamento';
import Operacional from './tabs/Operacional';
import EmpresasRelacionadas from './tabs/EmpresasRelacionadas';
import RegistrosRelevantes from './tabs/RegistrosRelevantes';
import { Tabs } from '../../../../app/components/Tabs';
import { FiArrowLeft } from "react-icons/fi";
import { useNavigate } from 'react-router-dom';
import { usePageTitle } from '../../../../contexts/PageTitleContext';



const FiscalManagementUI = () => {
  const { setTitle } = usePageTitle();

  useEffect(() => {
    setTitle('Prontuário do Cliente');
  }, [setTitle]);

  const [selectedTab, setSelectedTab] = useState('Visão Geral');
  const [imagePreview, setImagePreview] = useState(null);
  const navigate = useNavigate()

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const previewURL = URL.createObjectURL(file);
      setImagePreview(previewURL);
    }
  };

  const tabLabels = [
    'Visão Geral',
    'Relacionamento',
    'Operacional',
    'Empresas Relacionadas',
    'Registros Relevantes'
  ];

  const tabComponents = {
    'Visão Geral': <VisaoGeral />,
    'Relacionamento': <Relacionamento />,
    'Operacional': <Operacional />,
    'Empresas Relacionadas': <EmpresasRelacionadas />,
    'Registros Relevantes': <RegistrosRelevantes />
  };

  return (
    <div>
      <button onClick={() => navigate('/clientes')}>
        <FiArrowLeft size={20} className='text-gray-500'/>
      </button>
      <div className="h-full overflow-y-auto">
        <div className="bg-white rounded-lg p-6 shadow-sm mb-4">
          <div className="flex flex-col md:flex-row">
            <label htmlFor="fileInput" className="w-full md:w-64 h-40 cursor-pointer border-2 border-dashed border-gray-200 rounded-lg flex items-center justify-center hover:bg-gray-50 overflow-hidden">
              {imagePreview ? (
                <img
                  src={imagePreview}
                  alt="Pré-visualização"
                  className="w-full h-full object-cover"
                />
              ) : (
                <FaBuilding className="text-gray-400 text-6xl" />
              )}
              <input type="file" className="hidden" id="fileInput" onChange={handleFileChange} />
            </label>

            <div className="md:ml-8 md:flex-1">
              <h1 className="text-2xl font-bold text-gray-800 mb-6">ODOS ACELERADORA LTDA</h1>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <div>
                  <div className="flex items-center mb-2">
                    <span className="text-gray-500">Sócio-Administrador:</span>
                  </div>
                  <div className="flex items-center mb-2">
                    <span className="text-gray-500">Regime Tributário: teste b</span>
                  </div>
                </div>

                <div>
                  <div className="flex items-center mb-2">
                    <span className="text-gray-500">Honorário Mensal: R$</span>
                  </div>
                  <div className="flex items-center mb-2">
                    <span className="text-gray-500">Cidade: TERESINA</span>
                  </div>
                </div>

                <div>
                  <div className="flex items-center mb-2">
                    <span className="text-gray-500">Contato Principal: (00) 0000-0000</span>
                  </div>
                  <div className="flex items-center mb-2">
                    <span className="text-gray-500">Cliente desde: 00/00/0000</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Tabs
          tabsName={tabLabels}
          activeTabName={selectedTab}
          onTabClick={setSelectedTab}
        />

        <div className="mt-6">
          {tabComponents[selectedTab]}
        </div>
      </div>
    </div>
  );
};

export default FiscalManagementUI;
